var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvoice = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 2c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V7h-4c-.553 0-1-.447-1-1V2zm6 0v4h4zM6 4.5c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5m0 2c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5m4 2.25c.275 0 .5.225.5.5v.54c.266.038.522.098.753.16a.5.5 0 1 1-.26.966c-.346-.094-.687-.163-1.002-.166-.263-.003-.544.056-.738.172-.178.106-.253.228-.253.4 0 .116.04.203.228.316.216.128.519.221.913.34l.015.003c.353.107.79.238 1.135.457.378.237.7.615.709 1.193.01.603-.3 1.04-.716 1.3-.24.15-.512.238-.784.285v.534c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5v-.556a6.7 6.7 0 0 1-.966-.278 13 13 0 0 1-.193-.066.499.499 0 1 1 .315-.947c.078.025.15.05.222.075.425.144.769.263 1.134.272.285.01.56-.053.741-.166.16-.1.247-.228.244-.437-.003-.144-.056-.244-.24-.363-.213-.134-.516-.23-.907-.35l-.05-.015c-.344-.103-.76-.228-1.088-.428-.374-.225-.706-.591-.709-1.166-.003-.606.338-1.025.744-1.266.234-.137.494-.225.753-.271V9.25c0-.275.225-.5.5-.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invoice.74a8ea299af9d280e65afb46d40b4297.svg";